import React from 'react';
import { api, categoryUploadDir } from '../../../config';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './HomeItem.css';

const HomeItem = ({ categoryName, categoryLogo }) => {
  return (
    <div className={s.sliderItemBox}>
      <div className={s.sliderImageBox}>
        <img src={`${api.apiEndpoint}${categoryUploadDir}medium_${categoryLogo}`} alt={categoryName} />
        <span className={s.sliderImageBackEffect} />
      </div>
      <p className={s.categoryText}>{categoryName}</p>
    </div>
  );
};

export default withStyles(s)(HomeItem);
